import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetAuthListBo } from '../client-parent.model';
@Injectable({
  providedIn: 'root'
})
export class AuthDateService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public execute(Authstate: GetAuthListBo): void {
    this.getClientAuth(Authstate).subscribe(x => super.next(x));
  }
  getClientAuth(Authstate?: GetAuthListBo): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/ClientAuthorization/GetClientAuthList?", Authstate)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }
}
